module.exports = __webpack_public_path__ + "static/media/pytorch.2b15f965.svg";